export enum Gender {
    Male,
    Female
}

export const genderOptions = [
    { label: "Male", value: Gender.Male },
    { label: "Female", value: Gender.Female },
]